import React from 'react';

import { BottomSectionProps } from '@/modules/common/components/templates/data-reconciliation/components/parts/data-reconciliation-bottom-section';
import { EntityReconciliationStep } from '@/modules/data-reconciliation/pages/entity-reconciliation-step';
import { useClientsReconciliationConfig } from '@/modules/onboarding/clients-setup/config/clients-reconciliation-config';

export interface ClientsReconciliationStepPageProps {
  isInfiniteSizeTable?: boolean;
  onClickNext: () => void;
  bottomSection: (props: BottomSectionProps) => React.ReactNode;
  /** Reports dirty state changes (true when there are unsaved entity modifications) */
  onDirtyChange?: (isDirty: boolean) => void;
}

export const ClientsReconciliationStep: React.FC<ClientsReconciliationStepPageProps> = ({
  onClickNext,
  bottomSection,
  isInfiniteSizeTable,
  onDirtyChange,
}) => {
  const config = useClientsReconciliationConfig();

  return (
    <EntityReconciliationStep
      config={config}
      onClickNext={onClickNext}
      bottomSection={bottomSection}
      isInfiniteSizeTable={isInfiniteSizeTable}
      onDirtyChange={onDirtyChange}
    />
  );
};
